module.exports = __webpack_public_path__ + "img/13.56b63c5c.jpg";